import { Tab, Tabs, Typography } from '@material-ui/core';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { LgSpace } from 'm2m.components';
import React, { useState, useEffect } from 'react';
import { RouteComponentProps, withRouter, useHistory, useLocation } from 'react-router-dom';
import InstrumentoFinanceiro from './instrumentosFinanceiros';
import Participantes from './participantes';
import Credenciados from './credenciados';
import Aditamentos from './aditamentos';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { FuncaoParticipante } from 'common/genericTypes';
import InstrumentosEdicao from './instrumentosEdicao';

type Props = RouteComponentProps;

const tabMap: { [key: string]: number } = {
  'instrumentos-financeiros': 0,
  participantes: 1,
  credenciados: 2,
  aditamentos: 3,
  edicoes: 4,
};

const Aprovacoes: React.FC<Props> = () => {
  const isParticipanteEscriturador =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Escriturador;
  const isParticipanteAgenteFiduciario =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.AgenteFiduciario;
  const participanteFuncao = useSelector((state: RootState) => state.auth.usuario.participante.funcao);

  const history = useHistory();
  const location = useLocation();

  const getTabValueFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    return tab && tabMap[tab] !== undefined ? tabMap[tab] : 0;
  };

  const isRoleResolved = Boolean(participanteFuncao);
  const initialTab = isRoleResolved && isParticipanteAgenteFiduciario ? 3 : getTabValueFromQuery();
  const [tabValue, setTabValue] = useState<number>(initialTab);

  useEffect(() => {
    if (!isParticipanteAgenteFiduciario) {
      setTabValue(getTabValueFromQuery());
    } else {
      if (tabValue !== 3) setTabValue(3);
    }
  }, [location.search, isParticipanteAgenteFiduciario]);

  const handleTabChange = (_event: React.ChangeEvent<{}>, newTab: number) => {
    const tabName = Object.keys(tabMap).find((key) => tabMap[key] === newTab);
    if (tabName) {
      history.push(`${location.pathname}?tab=${tabName}`);
    }
  };

  if (!isRoleResolved) {
    return (
      <div style={{ marginRight: 40 }}>
        <Typography variant="h1">{'Aprovações e Histórico'}</Typography>
        <LgSpace />
      </div>
    );
  }

  return (
    <div style={{ marginRight: 40 }}>
      <Typography variant="h1">{'Aprovações e Histórico'}</Typography>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={handleTabChange}>
          {!isParticipanteAgenteFiduciario && <Tab label="Instrumentos Financeiros" value={0} />}
          {!isParticipanteEscriturador && !isParticipanteAgenteFiduciario && (
            <Tab label="Participantes" value={1} />
          )}
          {!isParticipanteEscriturador && !isParticipanteAgenteFiduciario && (
            <Tab label="Credenciados" value={2} />
          )}
          <Tab label="Aditamentos" value={3} />
          {!isParticipanteEscriturador && !isParticipanteAgenteFiduciario && (
            <Tab label="Edições" value={4} />
          )}
        </Tabs>
      </HorizontalAppBar>
      {!isParticipanteAgenteFiduciario && tabValue === 0 && <InstrumentoFinanceiro />}
      {!isParticipanteAgenteFiduciario && tabValue === 1 && <Participantes />}
      {!isParticipanteAgenteFiduciario && tabValue === 2 && <Credenciados />}
      {tabValue === 3 && <Aditamentos />}
      {!isParticipanteAgenteFiduciario && tabValue === 4 && <InstrumentosEdicao />}
      <LgSpace />
    </div>
  );
};

export default withRouter(Aprovacoes);
